import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import NumericInput from "react-numeric-input";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { AuthenticationContext } from "@cloudmlm/cloudmlm-auth";
import {
  Box,
  Button,
  Card,
  Stack,
  Typography,
  List,
  ListItem,
  Divider,
  Link as MuiLink,
  Dialog,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import {
  httpPost,
  httpGet,
  encryptData,
  DecryptData,
} from "../../services/commonService";
import urlConstant from "../../constants/urlConstants";
import dataConstant from "../../constants/dataConstants";
import i18n from "../../i18n";
import WithdrawalSliderSection from "./withDrawalSliderSection";
import CustomTextField from "../../shared-components/form-controls/customTextField";
import { messageConstant } from "../../constants/messageConstant";
import SnackState from "../../shared-components/snackbar/snackState";
import CommonSnackBar from "../../shared-components/snackbar/commonSnackbar";
import CustomMaskedTextField from "../../shared-components/form-controls/customMaskedTextField";

const WithDrawFunds = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const iWalletBalance =
    location.state?.iWalletBalance ??
    parseFloat(sessionStorage.getItem("iWalletBalance")) ??
    0;
  const authenticationState = useContext(AuthenticationContext);
  const [snack, closeSnack, showSnackbar] = SnackState();
  const [getDisplayWire, setDisplayWire] = useState(false);
  const [getDisplayACH, setDisplayACH] = useState(true);
  const [getDisplayUSDC, setDisplayUSDC] = useState(false);
  const [getDisplayBitCoin, setDisplayBitCoin] = useState(false);
  const [maxWithdrwal, setMaxWithdrwal] = useState(false);
  const [active, setActive] = useState(false);
  const [active2, setActive2] = useState(true);
  const [active3, setActive3] = useState(false);
  const [active4, setActive4] = useState(false);
  const [clearBankInfo, setClearBankInfo] = useState(false);
  const [editCheckbox, setEditCheckbox] = useState(false);
  const [disable, setDisable] = useState(false);
  const [getRemainingDays, setRemainingDays] = useState(0);
  const [bitcoinAddressRequired, setBitcoinAddressRequired] = useState(false);
  const [activeForWirePersonal, setActiveForWirePersonal] = useState(true);
  const [activeForWireBusiness, setActiveForWireBusiness] = useState(false);
  const [showEmailButton, setShowEmailButton] = useState(false);
  const [showUpdateAddressLink, setShowUpdateAddressLink] = useState(true);
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [ResendButtonDisable, setResendButtonDisable] = useState(false);

  const [getBitCoinWalletAddress, setBitCoinWalletAddress] = useState({
    refreshKey: Math.random(),
    BitCoinAddress: {
      BitCoinWalletAddress: "",
    },
    Email: "",
  });

  const [getState, setState] = useState({
    iWalletIsWireAllow: "",
    iWalletIsACHAllow: "",
    iWalletIsBitCoinAllow: "",
    iWalletIsUSDCAllow: "",
    isDisplay: true,
  });

  const [isiWalletCreated, setisiWalletCreated] = useState({
    TransactionDate: new Date().toLocaleString(),
    Deductions: 0,
    Earnings: 0,
    TransactionType: "Withdraw",
    Status: "Pending",
    Method: "ACH",
    Wire_AccountType: "Personal Checking Account",
  });

  const [getiWalletSummary, setIwalletSummary] = useState({
    pendingBalance: 0,
    minimumWithdrawalAmount: 0,
  });

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [getFeeList, setFeeList] = useState({
    ACH: 0,
    Wire: 0,
    BitCoin: 0,
    USDC: 0,
  });

  const [activeForACHPersonalAccount, setActiveForACHPersonalAccount] =
    useState(true);
  const [activeForACHBusinessAccount, setActiveForACHBusinessAccount] =
    useState(false);
  const [
    activeForACHBusinessSavingsAccount,
    setActiveForACHBusinessSavingsAccount,
  ] = useState(false);
  const [
    activeForACHPersonalSavingsAccount,
    setActiveForACHPersonalSavingsAccount,
  ] = useState(false);

  const [initialBankDetails, setInitialBankDetails] = useState({
    ACHbank_name: "",
    ACHbank_address: "",
    ACHbank_city: "",
    ACHbank_state: "",
    ACHbank_zip: "",
    ACH_routingNumber: "",
    ACH_accountNumber: "",
    ACH_firstName: "",
    AccountHolderName: "",
    AccountHolderAddress: "",
    AccountHolderTelephone: "",
    AccountNumber: "",
    Wire_RoutingNumber: "",
    BankName: "",
    BankBranchAddress: "",
    BankTelephone: "",
    ACH_BankAddress: "",
    ACH_BankState: "",
    ACH_BankCity: "",
    ACH_BankZipcode: "",
  });

  useEffect(() => {
    getUserDetailsById();
    getiWalletStatusList();
    getiWalletSummaryDetails();
    getFeeConfigurationList();
    iWalletDetails();
  }, []);

  useEffect(() => {
    getiWalletLatestWithdrawlBankingDetails();
  }, [isiWalletCreated.Wire_AccountType]);

  useEffect(() => {
    const feeAmount = getDisplayACH
      ? parseFloat(getFeeList.ACH)
      : getDisplayWire
      ? parseFloat(getFeeList.Wire)
      : getDisplayBitCoin
      ? parseFloat(getFeeList.BitCoin)
      : getDisplayUSDC
      ? parseFloat(getFeeList.USDC)
      : 0;

    const maxEarnings = parseFloat((iWalletBalance - feeAmount).toFixed(2));
    const earnings = parseFloat(isiWalletCreated.Earnings);

    setMaxWithdrwal(maxEarnings === earnings);
  }, [isiWalletCreated.Earnings]);

  const getiWalletStatusList = () => {
    httpPost(
      urlConstant.iWallet.ExternalPaymentConfigurationList,
      {},
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        const responseData = response.Value.Data;
        setState(() => ({
          iWalletIsWireAllow: responseData[0].iWalletIsWireAllow,
          iWalletIsACHAllow: responseData[0].iWalletIsACHAllow,
          iWalletIsBitCoinAllow: responseData[0].iWalletIsBitCoinAllow,
          iWalletIsUSDCAllow: responseData[0].iWalletIsUSDCAllow,
        }));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const WirePage = () => {
    setisiWalletCreated({
      ...isiWalletCreated,
      Method: "Wire",
      Wire_AccountType: "PERSONAL",
    });
    setActive(!active);
    setActive2(false);
    setActive3(false);
    setActive4(false);
    setDisplayWire(true);
    setDisplayUSDC(false);
    setDisplayACH(false);
    setDisplayBitCoin(false);
  };

  const WalletACHAddress = () => {
    setisiWalletCreated({
      ...isiWalletCreated,
      Method: "ACH",
      Wire_AccountType: "Personal Checking Account",
    });
    setActive2(!active2);
    setActive(false);
    setActive3(false);
    setActive4(false);
    setDisplayACH(true);
    setDisplayUSDC(false);
    setDisplayBitCoin(false);
    setDisplayWire(false);
  };

  const WalletUSDCAddress = () => {
    setisiWalletCreated({ ...isiWalletCreated, Method: "USDC" });
    setActive4(!active4);
    setActive2(false);
    setActive(false);
    setActive3(false);
    setDisplayUSDC(true);
    setDisplayACH(false);
    setDisplayBitCoin(false);
    setDisplayWire(false);
  };

  const WalletBitCoinAddress = () => {
    setisiWalletCreated({ ...isiWalletCreated, Method: "BitCoin" });
    setActive3(!active3);
    setActive2(false);
    setActive(false);
    setActive4(false);
    setDisplayBitCoin(true);
    setDisplayUSDC(false);
    setDisplayWire(false);
    setDisplayACH(false);
  };

  const getiWalletSummaryDetails = () => {
    httpGet(
      urlConstant.iWallet.GetiWalletSummary,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        const responseData = response.Value.Data;
        setIwalletSummary((prevState) => ({
          ...prevState,
          pendingBalance: responseData.TotaliWalletbalance
            ? `$${responseData.TotaliWalletbalance.toFixed(
                dataConstant.TwoDigitConstValue
              )}`
            : 0,
          minimumWithdrawalAmount: parseInt(
            responseData.MinimumWithdrawalAmount
          ),
        }));
        setisiWalletCreated((prevData) => ({
          ...prevData,
          Earnings: parseInt(responseData.MinimumWithdrawalAmount),
        }));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getFeeConfigurationList = () => {
    httpPost(
      urlConstant.FeeConfiguration.FeeConfigurationList,
      {},
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        const feeList = response.Value.Data;
        const ACHAmount = feeList.find((usr) => usr.FeeTitle.includes("ACH"))
          ? feeList.find((usr) => usr.FeeTitle.includes("ACH"))
          : 0;
        const WireAmount = feeList.find((usr) => usr.FeeTitle.includes("Wire"))
          ? feeList.find((usr) => usr.FeeTitle.includes("Wire"))
          : 0;
        const BitCoinAmount = feeList.find((usr) =>
          usr.FeeTitle.includes("BitCoin")
        )
          ? feeList.find((usr) => usr.FeeTitle.includes("BitCoin"))
          : 0;
        const USDCAmount = feeList.find((usr) => usr.FeeTitle.includes("USDC"))
          ? feeList.find((usr) => usr.FeeTitle.includes("USDC"))
          : 0;

        if (ACHAmount || WireAmount || BitCoinAmount || USDCAmount) {
          setFeeList(() => ({
            ACH: ACHAmount.FeeAmount,
            Wire: WireAmount.FeeAmount,
            BitCoin: BitCoinAmount.FeeAmount,
            USDC: USDCAmount.FeeAmount,
          }));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const iWalletDetails = () => {
    httpGet(
      urlConstant.User.GetUserSpecificDetails,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        const responseData = response.Value.Data;
        setisiWalletCreated((prevData) => ({
          ...prevData,
          AcctID: responseData.AcctID,
        }));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const onMaxAmountClick = () => {
    const feeAmount = getDisplayACH
      ? parseFloat(getFeeList.ACH)
      : getDisplayWire
      ? parseFloat(getFeeList.Wire)
      : getDisplayBitCoin
      ? parseFloat(getFeeList.BitCoin)
      : getDisplayUSDC
      ? parseFloat(getFeeList.USDC)
      : 0;

    setisiWalletCreated((prevState) => ({
      ...prevState,
      Earnings: (iWalletBalance - feeAmount).toFixed(
        dataConstant.TwoDigitConstValue
      ),
    }));
  };

  const ACHPersonalAccount = () => {
    setisiWalletCreated({
      ...isiWalletCreated,
      Wire_AccountType: "Personal Checking Account",
    });
    setActiveForACHPersonalAccount(!activeForACHPersonalAccount);
    setActiveForACHBusinessAccount(false);
    setActiveForACHPersonalSavingsAccount(false);
    setActiveForACHBusinessSavingsAccount(false);
  };

  const ACHBusinessAccount = () => {
    setisiWalletCreated({
      ...isiWalletCreated,
      Wire_AccountType: "Business Checking Account",
    });
    setActiveForACHPersonalAccount(false);
    setActiveForACHBusinessAccount(!activeForACHBusinessAccount);
    setActiveForACHPersonalSavingsAccount(false);
    setActiveForACHBusinessSavingsAccount(false);
  };

  const ACHPersonalSavingsAccount = () => {
    setisiWalletCreated({
      ...isiWalletCreated,
      Wire_AccountType: "Personal Savings Account",
    });
    setActiveForACHPersonalAccount(false);
    setActiveForACHBusinessAccount(false);
    setActiveForACHPersonalSavingsAccount(!activeForACHPersonalSavingsAccount);
    setActiveForACHBusinessSavingsAccount(false);
  };

  const ACHBusinessSavingsAccount = () => {
    setisiWalletCreated({
      ...isiWalletCreated,
      Wire_AccountType: "Business Savings Account",
    });
    setActiveForACHPersonalAccount(false);
    setActiveForACHBusinessAccount(false);
    setActiveForACHPersonalSavingsAccount(false);
    setActiveForACHBusinessSavingsAccount(!activeForACHBusinessSavingsAccount);
  };

  const iWalletWithdraw = (event) => {
    const model = {
      AcctID: isiWalletCreated.AcctID,
      Deductions: isiWalletCreated.Deductions,
      TransactionDate: isiWalletCreated.TransactionDate,
      Earnings: isiWalletCreated.Earnings,
      TransactionType: isiWalletCreated.TransactionType,
      Status: isiWalletCreated.Status,
      Method:
        isiWalletCreated.Method === undefined ? "ACH" : isiWalletCreated.Method,
      Wire_AccountType: isiWalletCreated.Wire_AccountType,
    };
    httpPost(
      urlConstant.iWallet.CreateiWallet,
      model,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        setisiWalletCreated(response);
        if (response.Status === dataConstant.APIResponseStatus.Success) {
          //props.history.push({ pathname: "/thankYou2" });
        } else if (response.error === "iWallet bitcoin address is required.") {
          setBitcoinAddressRequired(true);
        } else if (
          response.error ===
          "You have already requested a withdrawal within this week. Please try again next week."
        ) {
          setRemainingDays(response.Value.RemainingDays);
          setDisable(true);
        } else setDisable(true);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const isEncrypted = (data) => {
    return /^[A-Za-z0-9+/=]+$/.test(data) && data.length % 4 === 0;
  };

  const methods = useForm({
    defaultValues: {
      ACHbank_name: "",
      ACHbank_address: "",
      ACHbank_city: "",
      ACHbank_state: "",
      ACHbank_zip: "",
      ACH_routingNumber: "",
      ACH_accountNumber: "",
      ACH_firstName: "",
      AccountHolderName: "",
      AccountHolderAddress: "",
      AccountHolderTelephone: "",
      AccountNumber: "",
      Wire_RoutingNumber: "",
      BankName: "",
      BankBranchAddress: "",
      BankTelephone: "",
    },
    mode: "onChange",
  });

  const onAddNewDetailsClick = () => {
    setInitialBankDetails(() => ({
      ACHbank_name: "",
      ACHbank_address: "",
      ACHbank_city: "",
      ACHbank_state: "",
      ACHbank_zip: "",
      ACH_routingNumber: "",
      ACH_accountNumber: "",
      ACH_firstName: "",
      AccountHolderName: "",
      AccountHolderAddress: "",
      AccountHolderTelephone: "",
      AccountNumber: "",
      Wire_RoutingNumber: "",
      BankName: "",
      BankBranchAddress: "",
      BankTelephone: "",
      refreshKey: Math.random(),
    }));
    setEditCheckbox(true);
    setClearBankInfo(true);
  };

  const addNewBankingDetailsButton = (
    <Box textAlign="center" mb={2}>
      <Button
        type="button"
        onClick={onAddNewDetailsClick}
        variant={clearBankInfo ? "contained" : "contained"}
        color="secondary"
      >
        {t("IWallet.Clear to Enter New Banking Details")}
      </Button>
    </Box>
  );

  const { handleSubmit, reset, control } = methods;

  useEffect(() => {
    reset(initialBankDetails);
  }, [initialBankDetails, reset]);

  const getiWalletLatestWithdrawlBankingDetails = () => {
    httpGet(
      `${urlConstant.iWallet.GetiWalletLatestWithdrawlBankingDetailsByType}?Method=${isiWalletCreated.Method}&AccountType=${isiWalletCreated.Wire_AccountType}`,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        if (response.Value.Status === dataConstant.APIResponseStatus.Success) {
          const responseData = response.Value.Data;
          setInitialBankDetails(() => ({
            ACHbank_name: responseData.ACHbank_name || "",
            ACHbank_address: responseData.ACH_BankAddress || "",
            ACHbank_city: responseData.ACH_BankCity || "",
            ACHbank_state: responseData.ACH_BankState || "",
            ACHbank_zip: responseData.ACH_BankZipcode || "",
            ACH_routingNumber:
              responseData.ACH_routingNumber &&
              isEncrypted(responseData.ACH_routingNumber)
                ? DecryptData(responseData.ACH_routingNumber)
                : "",
            ACH_accountNumber:
              responseData.ACH_accountNumber &&
              isEncrypted(responseData.ACH_accountNumber)
                ? DecryptData(responseData.ACH_accountNumber)
                : "",
            ACH_firstName: responseData.ACH_firstName || "",
            AccountHolderName: responseData.AccountHolderName || "",
            AccountHolderAddress: responseData.AccountHolderAddress || "",
            AccountHolderTelephone: responseData.AccountHolderTelephone || "",
            AccountNumber:
              responseData.AccountNumber &&
              isEncrypted(responseData.AccountNumber)
                ? DecryptData(responseData.AccountNumber)
                : "",
            Wire_RoutingNumber:
              responseData.Wire_RoutingNumber &&
              isEncrypted(responseData.Wire_RoutingNumber)
                ? DecryptData(responseData.Wire_RoutingNumber)
                : "",
            BankName: responseData.BankName || "",
            BankBranchAddress: responseData.BankBranchAddress || "",
            BankTelephone: responseData.BankTelephone || "",
          }));
          setEditCheckbox(false);
        } else {
          onAddNewDetailsClick();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const onSubmit = (event) => {
    const model = {
      Wire_BankName: event.ACHbank_name,
      ACH_BankAddress: event.ACHbank_address,
      ACH_BankCity: event.ACHbank_city,
      ACH_BankState: event.ACHbank_state,
      ACH_BankZipcode: event.ACHbank_zip,
      ACH_RoutingNumber: encryptData(event.ACH_routingNumber),
      ACH_AccountNumber: encryptData(event.ACH_accountNumber),
      NameOnAccount: event.ACH_firstName,
      Notes: event.ACHagree,
      AcctID: isiWalletCreated.AcctID,
      Deductions: isiWalletCreated.Deductions,
      TransactionDate: isiWalletCreated.TransactionDate,
      Earnings: isiWalletCreated.Earnings,
      TransactionType: isiWalletCreated.TransactionType,
      Status: isiWalletCreated.Status,
      Method: isiWalletCreated.Method,
      Wire_AccountType:
        isiWalletCreated.Wire_AccountType === undefined
          ? "Personal Checking Account"
          : isiWalletCreated.Wire_AccountType,
    };
    httpPost(
      urlConstant.iWallet.CreateiWallet,
      model,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        setisiWalletCreated(response);
        if (response.Status === dataConstant.APIResponseStatus.Success) {
          navigate("/thankYou2");
        } else if (
          response.error ===
          "You have already requested a withdrawal within this week. Please try again next week."
        ) {
          setRemainingDays(response.Value.RemainingDays);
          setDisable(true);
        } else setDisable(true);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const formConfig = {
    ACHbank_name: {
      name: "ACHbank_name",
      label: t("IWallet.Name of Your Bank"),
      type: "text",
      required: true,
      maxLength: 100,
      isDisabled: !editCheckbox,
    },
    ACHbank_address: {
      name: "ACHbank_address",
      label: t("IWallet.Bank Branch Address"),
      type: "text",
      required: true,
      maxLength: 200,
      isDisabled: !editCheckbox,
    },
    ACHbank_city: {
      name: "ACHbank_city",
      label: t("IWallet.City of Your Bank"),
      type: "text",
      required: true,
      maxLength: 100,
      isDisabled: !editCheckbox,
    },
    ACHbank_state: {
      name: "ACHbank_state",
      label: t("IWallet.State of Your Bank"),
      type: "text",
      required: true,
      maxLength: 100,
      isDisabled: !editCheckbox,
    },
    ACHbank_zip: {
      name: "ACHbank_zip",
      label: t("IWallet.Zip"),
      type: "text",
      required: true,
      maxLength: 20,
      isDisabled: !editCheckbox,
    },
    ACH_routingNumber: {
      name: "ACH_routingNumber",
      label: t("IWallet.Routing Number"),
      type: "text",
      required: true,
      maxLength: 9,
      regex: /^\d{9}$/,
      isDisabled: !editCheckbox,
      visibleCharCount: 4,
      maskType: "partial",
    },
    ACH_accountNumber: {
      name: "ACH_accountNumber",
      label: t("IWallet.Account Number"),
      type: "text",
      required: true,
      minLength: 6,
      maxLength: 20,
      regex: /^\d{6,20}$/,
      isDisabled: !editCheckbox,
      visibleCharCount: 4,
      maskType: "partial",
    },
    ACH_firstName: {
      name: "ACH_firstName",
      label: t("IWallet.Name of the Account"),
      type: "text",
      required: true,
      maxLength: 100,
      isDisabled: !editCheckbox,
    },
    ACH_agree: {
      name: "ACH_agree",
      label: t("IWallet.Type I Agree to continue"),
      type: "text",
      required: true,
      maxLength: 100,
    },
    AccountHolderName: {
      name: "AccountHolderName",
      label: t("IWallet.AccountHolderName"),
      type: "text",
      required: true,
      maxLength: 100,
      isDisabled: !editCheckbox,
    },
    AccountHolderAddress: {
      name: "AccountHolderAddress",
      label: t("IWallet.AccountHoldersAddress"),
      type: "text",
      required: true,
      maxLength: 255,
      isDisabled: !editCheckbox,
    },
    AccountHolderTelephone: {
      name: "AccountHolderTelephone",
      label: t("IWallet.AccountHoldersTelephoneNumber"),
      type: "text",
      required: true,
      maxLength: 50,
      isDisabled: !editCheckbox,
    },
    AccountNumber: {
      name: "AccountNumber",
      label: t("IWallet.Account Number"),
      type: "text",
      required: true,
      minLength: 6,
      maxLength: 20,
      regex: /^\d{6,20}$/,
      isDisabled: !editCheckbox,
      visibleCharCount: 4,
      maskType: "partial",
    },
    Wire_RoutingNumber: {
      name: "Wire_RoutingNumber",
      label: t("IWallet.Routing Number"),
      type: "text",
      required: true,
      maxLength: 9,
      regex: /^\d{9}$/,
      isDisabled: !editCheckbox,
      visibleCharCount: 4,
      maskType: "partial",
    },
    BankName: {
      name: "BankName",
      label: t("IWallet.Name of Your Bank"),
      type: "text",
      required: true,
      maxLength: 50,
      isDisabled: !editCheckbox,
    },
    BankBranchAddress: {
      name: "BankBranchAddress",
      label: t("IWallet.BankBranchAddress"),
      type: "text",
      required: true,
      maxLength: 255,
      isDisabled: !editCheckbox,
    },
    BankTelephone: {
      name: "BankTelephone",
      label: t("IWallet.BankTelephone"),
      type: "text",
      required: true,
      maxLength: 50,
      isDisabled: !editCheckbox,
    },
    BitCoinWalletAddress: {
      name: "BitCoinWalletAddress",
      type: "text",
      isDisabled: true,
    },
    AccessCode: {
      name: "AccessCode",
      label: t("IWallet.Enter code here"),
      type: "text",
      required: true,
    },
  };

  const WirePersonalMode = () => {
    setisiWalletCreated({
      ...isiWalletCreated,
      Wire_AccountType: "PERSONAL",
    });
    setActiveForWirePersonal(!activeForWirePersonal);
    setActiveForWireBusiness(false);
  };

  const WireBusinessMode = () => {
    setisiWalletCreated({
      ...isiWalletCreated,
      Wire_AccountType: "BUSINESS",
    });
    setActiveForWirePersonal(false);
    setActiveForWireBusiness(!activeForWireBusiness);
  };

  const handleSubmitWire = (data) => {
    const model = {
      Wire_AccountHolderName: data.AccountHolderName,
      Wire_AccountHolderAddress: data.AccountHolderAddress,
      Wire_AccountHolderTel: data.AccountHolderTelephone,
      Wire_AccountNumber: encryptData(data.AccountNumber),
      Wire_RoutingNumber: encryptData(data.Wire_RoutingNumber),
      Wire_BankName: data.BankName,
      Wire_BankAddress: data.BankBranchAddress,
      Wire_BankTel: data.BankTelephone,
      AcctID: isiWalletCreated.AcctID,
      Deductions: isiWalletCreated.Deductions,
      TransactionDate: isiWalletCreated.TransactionDate,
      Earnings: isiWalletCreated.Earnings,
      TransactionType: isiWalletCreated.TransactionType,
      Status: isiWalletCreated.Status,
      Method: isiWalletCreated.Method,
      Wire_AccountType:
        isiWalletCreated.Wire_AccountType === undefined
          ? "PERSONAL"
          : isiWalletCreated.Wire_AccountType,
    };
    httpPost(
      urlConstant.iWallet.CreateiWallet,
      model,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        setisiWalletCreated(response);
        if (response.Status === dataConstant.APIResponseStatus.Success) {
          navigate("/thankYou2");
        } else if (
          response.error ===
          "You have already requested a withdrawal within this week. Please try again next week."
        ) {
          setRemainingDays(response.Value.RemainingDays);
          setDisable(true);
        } else setDisable(true);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const SendEmail = () => {
    const model = {
      AcctId: isiWalletCreated.AcctID,
    };
    httpPost(
      urlConstant.iWallet.SendAccessCode,
      model,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        if (response.Status === dataConstant.APIResponseStatus.Success) {
          setIsPopupOpen(true);
        }
        if (
          response.error ===
          "You have reached the 5 attempts.The account is locked for 30 minutes.Please try again after 30 minutes."
        ) {
          showSnackbar(response.error, "error");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const ShowButton = () => {
    setShowEmailButton(true);
    setShowUpdateAddressLink(false);
  };

  const CompareAccessCode = (event) => {
    const model = {
      AcctId: isiWalletCreated.AcctID,
      AccessCode: event.AccessCode,
    };
    httpPost(
      urlConstant.iWallet.CompareAccessCode,
      model,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    )
      .then((response) => {
        const { Status, Message } = response;
        if (Status === dataConstant.APIResponseStatus.Success) {
          navigate("/UpdateWalletAddress");
        } else {
          showSnackbar(Message, "error");

          if (Message.includes("5 attempts")) {
            setResendButtonDisable(true);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const OpenSubmitCodeForm = () => {
    setShowSubmitButton(true);
    setIsPopupOpen(false);
    setShowEmailButton(false);
    setShowUpdateAddressLink(false);
  };

  const checkbox1Validator = (value) => {
    if (!value) {
      return (
        i18n.t(messageConstant.SelectRequired) + i18n.t("IWallet.CheckBoxCheck")
      );
    }
    return true;
  };

  const getUserDetailsById = () => {
    const getPublicInfoURL = urlConstant.User.GetPrivateInfoById;
    httpGet(
      getPublicInfoURL,
      true,
      true,
      authenticationState.accessToken,
      authenticationState.impersonateEmail
    ).then((response) => {
      const responseData = response.Value.Data;
      setBitCoinWalletAddress((getBitCoinWalletAddress) => ({
        ...getBitCoinWalletAddress,
        refreshKey: Math.random(),
        BitCoinAddress: {
          ...getBitCoinWalletAddress.BitCoinAddress,
          BitCoinWalletAddress: responseData.BitCoinWalletAddress,
        },
        Email: responseData.Email,
      }));
    });
  };

  return (
    <>
      <Box flexDirection={"column"} gap={2} display={"flex"}>
        <Typography color="secondary.light" variant="h4" fontWeight={600}>
          {t("My Account")}
        </Typography>
        <Box width={"100%"}>
          <Card
            sx={(theme) => ({
              p: { xs: "20px", sm: "25px 30px" },
              background: theme.palette.background.cardGradient,
              borderRadius: "20px",
              height: "100%",
            })}
          >
            <Stack gap={"20px"}>
              <Typography color="secondary.light" variant="h4" fontWeight={600}>
                {t("IWallet.Withdraw Funds")}
              </Typography>

              <Card
                sx={(theme) => ({
                  p: { xs: "20px", sm: "25px 30px" },
                  background: theme.palette.common.black,
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: "700px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  gap: 2.5,
                })}
              >
                <Typography
                  color="secondary.light"
                  variant="h5"
                  fontWeight={500}
                >
                  {t("IWallet.iWallet Withdraw Request")}
                </Typography>
                <Button
                  variant="contained"
                  size="large"
                  color="secondary"
                  disableElevation
                  sx={{
                    px: 1,
                    py: 1,
                    margin: 0,
                    "& .MuiButton-startIcon": { margin: 0 },
                    "&:hover": { background: "var(--secondary-main)" },
                  }}
                  startIcon={
                    <CreditCardOutlinedIcon
                      sx={{ color: "white", height: "auto", width: "65px" }}
                    />
                  }
                />

                <Stack textAlign={"center"} gap={1.25}>
                  <Typography
                    color="secondary.light"
                    variant="h6"
                    fontWeight={500}
                    mt={3}
                  >
                    {t("IWallet.Select your payment type")}
                  </Typography>
                  <Stack
                    direction={"row"}
                    gap={2}
                    alignItems={"center"}
                    flexWrap={"wrap"}
                    justifyContent={"center"}
                  >
                    {getState.iWalletIsWireAllow === "Yes" && (
                      <Button
                        variant={active ? "contained" : "outlined"}
                        color="primary"
                        onClick={WirePage}
                        sx={{ mr: 1, px: 3 }}
                      >
                        {t("IWallet.WIRE")}
                      </Button>
                    )}
                    {getState.iWalletIsACHAllow === "Yes" && (
                      <Button
                        variant={active2 ? "contained" : "outlined"}
                        color="primary"
                        onClick={WalletACHAddress}
                        sx={{ mr: 1, px: 3 }}
                      >
                        {t("IWallet.ACH")}
                      </Button>
                    )}
                    {getState.iWalletIsUSDCAllow === "Yes" && (
                      <Button
                        variant={active4 ? "contained" : "outlined"}
                        color="primary"
                        onClick={WalletUSDCAddress}
                        sx={{ mr: 1, px: 3 }}
                      >
                        {t("IWallet.USDC")}
                      </Button>
                    )}
                    {getState.iWalletIsBitCoinAllow === "Yes" && (
                      <Button
                        variant={active3 ? "contained" : "outlined"}
                        color="primary"
                        onClick={WalletBitCoinAddress}
                        sx={{ mr: 1, px: 3 }}
                      >
                        {t("IWallet.USD Coin(BitCoin)")}
                      </Button>
                    )}
                  </Stack>
                </Stack>

                <Stack gap={0.5} alignItems={"center"}>
                  <Typography
                    color="secondary.light"
                    variant="h4"
                    fontWeight={500}
                    mt={3}
                  >
                    {getiWalletSummary.pendingBalance === 0
                      ? `$${getiWalletSummary.pendingBalance.toFixed(
                          dataConstant.TwoDigitConstValue
                        )}`
                      : getiWalletSummary.pendingBalance}{" "}
                    {t("Common.USD")}
                  </Typography>
                  <Typography color="secondary.text" variant="body2">
                    {t("IWallet.iWallet Balance")}
                  </Typography>
                </Stack>

                <Stack width={"100%"} className="cm-withdraw-slider">
                  <Typography
                    color="secondary.text"
                    variant="body2"
                    textAlign={"left"}
                  >
                    {t("IWallet.Withdraw Amount")}
                  </Typography>

                  <NumericInput
                    id="number"
                    className="cm-textfield-slided"
                    name="number"
                    pattern="[0-9].[0-9][0-9]"
                    defaultValue={getiWalletSummary.minimumWithdrawalAmount}
                    value={
                      isiWalletCreated.Earnings === 0 ||
                      isiWalletCreated.Earnings === undefined
                        ? getiWalletSummary.minimumWithdrawalAmount
                        : isiWalletCreated.Earnings
                    }
                    type="number"
                    onChange={(event) =>
                      setisiWalletCreated({
                        ...isiWalletCreated,
                        Earnings: event,
                      })
                    }
                    i18n={i18n}
                    required
                  />

                  {getDisplayWire && (
                    <WithdrawalSliderSection
                      label={t("IWallet.WIRE")}
                      fee={getFeeList?.Wire}
                      balance={iWalletBalance}
                      earnings={isiWalletCreated.Earnings}
                      minAmount={getiWalletSummary.minimumWithdrawalAmount}
                      t={t}
                      currency="USD"
                      showSlider={true}
                      showCard={true}
                      onChange={(val) =>
                        setisiWalletCreated({
                          ...isiWalletCreated,
                          Earnings: val,
                        })
                      }
                    />
                  )}
                  {getDisplayACH && (
                    <WithdrawalSliderSection
                      label={t("IWallet.ACH")}
                      fee={getFeeList?.ACH}
                      balance={iWalletBalance}
                      earnings={isiWalletCreated.Earnings}
                      minAmount={getiWalletSummary.minimumWithdrawalAmount}
                      t={t}
                      currency="USD"
                      showSlider={true}
                      showCard={true}
                      onChange={(val) =>
                        setisiWalletCreated({
                          ...isiWalletCreated,
                          Earnings: val,
                        })
                      }
                    />
                  )}
                  {getDisplayUSDC && (
                    <WithdrawalSliderSection
                      label={t("IWallet.USDC")}
                      fee={getFeeList?.USDC}
                      balance={iWalletBalance}
                      earnings={isiWalletCreated.Earnings}
                      minAmount={getiWalletSummary.minimumWithdrawalAmount}
                      t={t}
                      currency="USD"
                      showSlider={true}
                      showCard={true}
                      onChange={(val) =>
                        setisiWalletCreated({
                          ...isiWalletCreated,
                          Earnings: val,
                        })
                      }
                    />
                  )}
                  {getDisplayBitCoin && (
                    <WithdrawalSliderSection
                      label={t("IWallet.USD Coin(BitCoin)")}
                      fee={getFeeList?.BitCoin}
                      balance={iWalletBalance}
                      earnings={isiWalletCreated.Earnings}
                      minAmount={getiWalletSummary.minimumWithdrawalAmount}
                      t={t}
                      currency="USD"
                      showSlider={true}
                      showCard={true}
                      onChange={(val) =>
                        setisiWalletCreated({
                          ...isiWalletCreated,
                          Earnings: val,
                        })
                      }
                      availableEarnings={getiWalletSummary.pendingBalance}
                    />
                  )}
                </Stack>

                <Button
                  type="button"
                  variant={maxWithdrwal ? "contained" : "contained"}
                  color="secondary"
                  sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                  onClick={onMaxAmountClick}
                >
                  {t("IWallet.MaxAmount")}{" "}
                </Button>

                <Stack gap={0.5} alignItems={"center"}>
                  <Typography
                    color="secondary.light"
                    variant="h4"
                    fontWeight={500}
                    mt={3}
                  >
                    {t("Common.Dollar")}
                    {isiWalletCreated.Earnings === 0 ||
                    isiWalletCreated.Earnings === undefined
                      ? getiWalletSummary.minimumWithdrawalAmount
                      : isiWalletCreated.Earnings}{" "}
                    {t("Common.USD")}
                  </Typography>
                  <Typography
                    color="secondary.text"
                    variant="body2"
                    sx={{ fontSize: "12px" }}
                  >
                    {t("IWallet.Total Withdrawal")}
                  </Typography>
                </Stack>

                {getDisplayACH && (
                  <form onSubmit={handleSubmit(onSubmit)} className="w-100">
                    <Typography
                      color="secondary.text"
                      variant="body2"
                      textAlign="center"
                      mt={2}
                    >
                      {t("IWallet.Requet Fund Transfer")}
                    </Typography>
                    <Typography
                      color="secondary.light"
                      variant="h5"
                      textAlign="center"
                      fontWeight={600}
                      sx={{ mt: 3, mb: 3 }}
                    >
                      {t(
                        "IWallet.Authorization Agreement for Direct Deposits (ACH Credits)"
                      )}
                    </Typography>
                    <Typography
                      color="secondary.text"
                      variant="body2"
                      textAlign="center"
                    >
                      {t("IWallet.Authorize BYLD Network")}
                    </Typography>

                    <Box display="flex" justifyContent="center">
                      <Typography
                        sx={{ mt: 4 }}
                        variant="h5"
                        component="h5"
                        textAlign="center"
                        color="secondary.light"
                        fontWeight={600}
                      >
                        {t("IWallet.Select one")}
                      </Typography>
                    </Box>
                    <Stack gap={"20px"} mt={"20px"}>
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        justifyContent={"center"}
                        gap={2}
                        textAlign="center"
                      >
                        <Button
                          variant="contained"
                          color={
                            activeForACHPersonalAccount
                              ? "primary"
                              : "secondary"
                          }
                          onClick={ACHPersonalAccount}
                          sx={{
                            borderRadius: 2,
                            width: { xs: "100%", sm: "initial" },
                          }}
                        >
                          {t("IWallet.Personal Checking Account")}
                        </Button>
                        <Button
                          variant="contained"
                          color={
                            activeForACHBusinessAccount
                              ? "primary"
                              : "secondary"
                          }
                          onClick={ACHBusinessAccount}
                          sx={{
                            borderRadius: 2,
                            width: { xs: "100%", sm: "initial" },
                          }}
                        >
                          {t("IWallet.Business Checking Account")}
                        </Button>
                      </Stack>
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        justifyContent={"center"}
                        gap={2}
                        textAlign="center"
                      >
                        <Button
                          variant="contained"
                          color={
                            activeForACHPersonalSavingsAccount
                              ? "primary"
                              : "secondary"
                          }
                          onClick={ACHPersonalSavingsAccount}
                          sx={{
                            borderRadius: 2,
                            width: { xs: "100%", sm: "initial" },
                          }}
                        >
                          {t("IWallet.Personal Savings Account")}
                        </Button>
                        <Button
                          variant="contained"
                          color={
                            activeForACHBusinessSavingsAccount
                              ? "primary"
                              : "secondary"
                          }
                          onClick={ACHBusinessSavingsAccount}
                          sx={{
                            borderRadius: 2,
                            width: { xs: "100%", sm: "initial" },
                          }}
                        >
                          {t("IWallet.Business Savings Account")}
                        </Button>
                      </Stack>
                    </Stack>

                    <Typography
                      sx={{ mt: 4, mb: 3 }}
                      color="secondary.text"
                      variant="body2"
                      textAlign="center"
                    >
                      {t("IWallet.Depository Financial Institution")}
                    </Typography>

                    {addNewBankingDetailsButton}
                    <Card
                      className="hero-section"
                      sx={(theme) => ({
                        p: {
                          xs: "20px",
                        },
                        background: theme.palette.background.cardGradient,
                        borderRadius: "20px",
                        width: "100%",
                      })}
                    >
                      <Typography
                        color="common.white"
                        variant="h5"
                        textAlign="center"
                        fontWeight={600}
                      >
                        {t("IWallet.Bank Information")}
                      </Typography>
                      <Stack gap={"20px"} mt={"20px"}>
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.ACHbank_name}
                        />
                        <Typography
                          color="secondary.text"
                          variant="body2"
                          textAlign="center"
                        >
                          {t("IWallet.Location where the account was opened")}
                        </Typography>
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.ACHbank_address}
                        />
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.ACHbank_city}
                        />
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.ACHbank_state}
                        />
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.ACHbank_zip}
                        />
                      </Stack>
                      <Typography
                        color="secondary.text"
                        variant="body2"
                        textAlign="center"
                        sx={{ pt: 2 }}
                      >
                        {t("IWallet.Please Note the Location")}
                      </Typography>
                    </Card>

                    <Box
                      display="flex"
                      justifyContent="center"
                      ma
                      sx={{
                        mt: 2,
                        mb: 2,
                        width: "100%",
                        mx: "auto",
                      }}
                    >
                      <img
                        style={{
                          objectFit: "contain",
                          width: "100%",
                          maxWidth: "345px",
                        }}
                        src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/cheque.png`}
                        alt="Cheque"
                      />
                    </Box>

                    <Typography
                      color="secondary.text"
                      variant="body2"
                      textAlign="center"
                    >
                      {t("IWallet.IMPORTANT")}
                    </Typography>

                    <Stack gap={"20px"} sx={{ mb: 2 }}>
                      <CustomMaskedTextField
                        methods={methods}
                        properties={formConfig.ACH_routingNumber}
                      />
                      <CustomMaskedTextField
                        methods={methods}
                        properties={formConfig.ACH_accountNumber}
                      />
                      {(activeForACHBusinessAccount ||
                        activeForACHBusinessSavingsAccount) && (
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.ACH_firstName}
                        />
                      )}
                      {(activeForACHPersonalAccount ||
                        activeForACHPersonalSavingsAccount) && (
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.ACH_firstName}
                        />
                      )}
                    </Stack>

                    <Card
                      className="hero-section"
                      sx={(theme) => ({
                        p: {
                          xs: "20px",
                        },
                        background: theme.palette.background.cardGradient,
                        borderRadius: "20px",
                        width: "100%",
                        gap: 2,
                        display: "flex",
                        flexDirection: "column",
                      })}
                    >
                      <Typography
                        color="secondary.text"
                        variant="body1"
                        textAlign="center"
                        fontWeight={600}
                      >
                        {t("IWallet.Required")}
                      </Typography>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.ACH_agree}
                      />
                    </Card>
                    <Typography
                      color="secondary.text"
                      variant="body2"
                      textAlign="center"
                      sx={{ mt: 2 }}
                    >
                      {t("IWallet.NOTICE")}
                    </Typography>

                    {disable && (
                      <Box textAlign="center">
                        <Typography color="error" variant="body2">
                          {t("IWallet.AlreadyRequested")} {getRemainingDays}{" "}
                          {t("IWallet.Days")}
                        </Typography>
                      </Box>
                    )}

                    <Box display="flex" justifyContent="center" mt={2}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={
                          disable ||
                          isiWalletCreated.Earnings === 0 ||
                          isiWalletCreated.Earnings === undefined ||
                          isiWalletCreated.Earnings <
                            getiWalletSummary.minimumWithdrawalAmount ||
                          isiWalletCreated.Earnings >
                            iWalletBalance - parseFloat(getFeeList.ACH)
                        }
                      >
                        {t("IWallet.RequestWithdraw")}
                      </Button>
                    </Box>
                  </form>
                )}

                {getDisplayWire && (
                  <form onSubmit={handleSubmit(handleSubmitWire)}>
                    <List
                      sx={{
                        mb: 2,
                        pl: 4,
                        listStyleType: "disc",
                        listStylePosition: "inside",
                      }}
                      component="ul"
                    >
                      <ListItem sx={{ display: "list-item", py: 0 }}>
                        <Typography component="span" variant="body2">
                          {t("IWallet.A wire fee of $")}
                          {getFeeList.Wire + " "}
                          {t(
                            "IWallet.Will be deducted from the withdrawal amount"
                          )}
                        </Typography>
                      </ListItem>

                      <ListItem sx={{ display: "list-item", py: 0 }}>
                        <Typography component="span" variant="body2">
                          {t("IWallet.Amount of Withdrawal Must Be At Least") +
                            " "}
                          {getiWalletSummary.minimumWithdrawalAmount + " USD."}
                        </Typography>
                      </ListItem>

                      <ListItem sx={{ display: "list-item", py: 0 }}>
                        <Typography component="span" variant="body2">
                          {t("IWallet.Note3")}
                        </Typography>
                      </ListItem>
                    </List>
                    <Box>
                      <Typography variant="body2">
                        {t("IWallet.iWalletWireNote")}
                      </Typography>

                      <Divider sx={{ my: 2 }} />

                      <Box textAlign="center">
                        <Typography variant="h6" color="primary">
                          {t("IWallet.Account Type")}
                        </Typography>
                      </Box>
                    </Box>
                    <Box textAlign="center" className="cm-wallet-buttons">
                      <Button
                        variant={
                          activeForWirePersonal ? "contained" : "outlined"
                        }
                        color="primary"
                        onClick={WirePersonalMode}
                        sx={{ mr: 1, m: "6px 12px" }}
                      >
                        {t("IWallet.PERSONAL")}
                      </Button>
                      <Button
                        variant={
                          activeForWireBusiness ? "contained" : "outlined"
                        }
                        color="primary"
                        onClick={WireBusinessMode}
                        sx={{ mr: 1, m: "6px 12px" }}
                      >
                        {t("IWallet.BUSINESS")}
                      </Button>
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    {addNewBankingDetailsButton}
                    <Box textAlign="center">
                      <Typography variant="h5" color="primary">
                        {t("IWallet.Bank Information")}
                      </Typography>
                    </Box>
                    <Stack gap={"20px"}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.AccountHolderName}
                      />
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.AccountHolderAddress}
                      />
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.AccountHolderTelephone}
                      />
                      <CustomMaskedTextField
                        methods={methods}
                        properties={formConfig.AccountNumber}
                      />
                      <CustomMaskedTextField
                        methods={methods}
                        properties={formConfig.Wire_RoutingNumber}
                      />
                    </Stack>
                    <Box my={2} textAlign="center">
                      <Typography variant="body2">
                        {t("IWallet.iWalletWireIMPORTANT")}
                      </Typography>
                    </Box>
                    <Stack gap={"20px"}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.BankName}
                      />
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.BankBranchAddress}
                      />
                      <Typography variant="body2" color="text.secondary">
                        {t("IWallet.AccountOpen")}
                      </Typography>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.BankTelephone}
                      />
                    </Stack>
                    <Box my={2} textAlign="center">
                      <Typography variant="body2">
                        {t("IWallet.NOTICE")}
                      </Typography>
                    </Box>
                    {disable && (
                      <Box textAlign="center">
                        <Typography color="error" variant="body2">
                          {t("IWallet.AlreadyRequested")}
                          {getRemainingDays}
                          {t("IWallet.Days")}
                        </Typography>
                      </Box>
                    )}
                    <Box textAlign="center" pb={1}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={
                          disable ||
                          isiWalletCreated.Earnings === 0 ||
                          isiWalletCreated.Earnings === undefined ||
                          isiWalletCreated.Earnings <
                            getiWalletSummary.minimumWithdrawalAmount ||
                          isiWalletCreated.Earnings >
                            iWalletBalance - parseFloat(getFeeList.Wire)
                        }
                      >
                        {t("IWallet.RequestWithdraw")}
                      </Button>
                    </Box>
                  </form>
                )}

                {getDisplayBitCoin && (
                  <form onSubmit={handleSubmit(iWalletWithdraw)}>
                    <List sx={{ listStyleType: "disc", pl: 4 }}>
                      <ListItem sx={{ display: "list-item", py: 0 }}>
                        <Typography variant="body2">
                          {t("IWallet.A BitCoin Fee of ") + " "}
                          {getFeeList.BitCoin + " "}
                          {t(
                            "IWallet.Will be deducted from the withdrawal amount"
                          )}
                        </Typography>
                      </ListItem>

                      <ListItem sx={{ display: "list-item", py: 0 }}>
                        <Typography variant="body2">
                          {t("IWallet.Amount of Withdrawal Must Be At Least") +
                            " "}
                          {getiWalletSummary.minimumWithdrawalAmount + " USD."}
                        </Typography>
                      </ListItem>

                      <ListItem sx={{ display: "list-item", py: 0 }}>
                        <Typography variant="body2">
                          {t("IWallet.Note3")}
                        </Typography>
                      </ListItem>
                    </List>
                    <Divider sx={{ my: 2 }} />
                    <Box textAlign="center" my={1}>
                      <Typography variant="body1">
                        {t(
                          "IWallet.My USD Coin (BitCoin)(Uses Ether) Wallet Address"
                        )}
                      </Typography>
                    </Box>
                    <CustomTextField
                      methods={methods}
                      properties={formConfig.BitCoinWalletAddress}
                    />
                    <Box textAlign="center" my={1}>
                      {showEmailButton && (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={SendEmail}
                          sx={{ mx: 1 }}
                        >
                          {t("IWallet.Send Code")}
                        </Button>
                      )}

                      {showUpdateAddressLink && (
                        <MuiLink
                          component="button"
                          onClick={ShowButton}
                          underline="always"
                          sx={{ ml: 2 }}
                          className="lnk-border"
                        >
                          {t("IWallet.Update my BitCoin wallet address")}
                        </MuiLink>
                      )}
                    </Box>

                    <Dialog
                      className="login-popup"
                      sx={{ borderRadius: "20px", background: "transparent" }}
                      open={isPopupOpen}
                      onClose={() => setIsPopupOpen(false)}
                    >
                      <DialogContent>
                        <Typography
                          variant="body1"
                          color="secondary.light"
                          mb={"20px"}
                        >
                          {t("IWallet.emailSendMsg")}
                          {getBitCoinWalletAddress.Email}.
                        </Typography>
                        <Stack direction={"row"} justifyContent={"flex-end"}>
                          <Button
                            onClick={OpenSubmitCodeForm}
                            variant="contained"
                            color="primary"
                            sx={{ px: 3 }}
                          >
                            {t("Common.Close")}
                          </Button>
                        </Stack>
                      </DialogContent>
                    </Dialog>
                    {showSubmitButton && (
                      <>
                        <Typography variant="body2" mb={2}>
                          {t("IWallet.SendEmailImportantNote")}
                        </Typography>
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.AccessCode}
                        />
                        <Box textAlign="center" mt={2}>
                          <Button
                            variant="contained"
                            type="button"
                            color="primary"
                            onClick={() => {
                              const accessCode =
                                methods.getValues("AccessCode");
                              CompareAccessCode({ AccessCode: accessCode });
                            }}
                          >
                            {t("Common.Submit")}
                          </Button>

                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ ml: 2 }}
                            onClick={SendEmail}
                            disabled={ResendButtonDisable}
                          >
                            {t("IWallet.ReSend Code")}
                          </Button>
                        </Box>
                      </>
                    )}
                    <Box textAlign="center" sx={{ mb: 1 }}>
                      <Typography variant="body2">
                        {t("IWallet.iWallet DISCLAIMER")}
                      </Typography>
                    </Box>
                    <Grid item xs={12} sm={6} md={12}>
                      <Controller
                        name="checked1"
                        control={control}
                        rules={{ validate: checkbox1Validator }}
                        render={({ field, fieldState: { error } }) => (
                          <>
                            <FormControlLabel
                              control={<Checkbox {...field} />}
                              label={
                                <Typography variant="body2">
                                  {t("IWallet.Terms and Conditions1")}
                                </Typography>
                              }
                            />
                            {error && (
                              <Typography variant="caption" color="error">
                                {error.message}
                              </Typography>
                            )}
                          </>
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={12}>
                      <Controller
                        name="checked2"
                        control={control}
                        rules={{ validate: checkbox1Validator }}
                        render={({ field, fieldState: { error } }) => (
                          <>
                            <FormControlLabel
                              control={<Checkbox {...field} />}
                              label={
                                <Typography variant="body2">
                                  {t("IWallet.Terms and Conditions2")}
                                </Typography>
                              }
                            />
                            {error && (
                              <Typography variant="caption" color="error">
                                {error.message}
                              </Typography>
                            )}
                          </>
                        )}
                      />
                    </Grid>
                    {disable && (
                      <Box textAlign="center" my={2}>
                        <Typography variant="body1" color="error">
                          {t("IWallet.AlreadyRequested")} {getRemainingDays}{" "}
                          {t("IWallet.Days")}
                        </Typography>
                      </Box>
                    )}
                    {bitcoinAddressRequired && (
                      <Box textAlign="center" my={2}>
                        <Typography variant="body1" color="error">
                          {t("IWallet.BitcoinAddressRequired")}
                        </Typography>
                      </Box>
                    )}
                    <Box textAlign="center" pb={1}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={
                          disable ||
                          bitcoinAddressRequired ||
                          isiWalletCreated.Earnings === 0 ||
                          isiWalletCreated.Earnings === undefined ||
                          isiWalletCreated.Earnings <
                            getiWalletSummary.minimumWithdrawalAmount ||
                          isiWalletCreated.Earnings >
                            iWalletBalance - parseFloat(getFeeList.BitCoin)
                        }
                      >
                        {t("IWallet.RequestWithdraw")}
                      </Button>
                    </Box>
                  </form>
                )}

                {getDisplayUSDC && (
                  <form onSubmit={handleSubmit(iWalletWithdraw)}>
                    <List
                      sx={{
                        mb: 2,
                        pl: 4,
                        listStyleType: "disc",
                        listStylePosition: "inside",
                      }}
                      component="ul"
                    >
                      <ListItem sx={{ display: "list-item", py: 0 }}>
                        <Typography component="span" variant="body2">
                          {t("IWallet.USDC coin fee of $")}
                          {getFeeList.USDC + " "}
                          {t(
                            "IWallet.Will be deducted from the withdrawal amount"
                          )}
                        </Typography>
                      </ListItem>
                      <ListItem sx={{ display: "list-item", py: 0 }}>
                        <Typography component="span" variant="body2">
                          {t("IWallet.Amount of Withdrawal Must Be At Least") +
                            getiWalletSummary.minimumWithdrawalAmount +
                            " USD."}
                        </Typography>
                      </ListItem>
                      <ListItem sx={{ display: "list-item", py: 0 }}>
                        <Typography component="span" variant="body2">
                          {t("IWallet.Note3")}
                        </Typography>
                      </ListItem>
                    </List>
                    <Divider sx={{ my: 2 }} />
                    <Box textAlign="center">
                      <Typography variant="body2">
                        {t(
                          "IWallet.My USD Coin (USDC)(Uses Ether) Wallet Address"
                        )}
                      </Typography>
                    </Box>
                    <CustomTextField
                      methods={methods}
                      properties={formConfig.BitCoinWalletAddress}
                    />
                    <Box textAlign="center" my={1}>
                      {showEmailButton && (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={SendEmail}
                          sx={{ mr: 2 }}
                        >
                          {t("IWallet.Send Code")}
                        </Button>
                      )}
                      {showUpdateAddressLink && (
                        <MuiLink
                          component="button"
                          variant="body2"
                          onClick={ShowButton}
                          sx={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          {t("IWallet.Update my USDC Wallet Address")}
                        </MuiLink>
                      )}
                    </Box>
                    <Dialog
                      open={isPopupOpen}
                      onClose={() => setIsPopupOpen(false)}
                    >
                      <DialogContent>
                        <Typography>
                          {t("IWallet.emailSendMsg")}{" "}
                          {getBitCoinWalletAddress.Email}.
                        </Typography>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={OpenSubmitCodeForm}
                          color="primary"
                          variant="contained"
                        >
                          {t("Common.Close")}
                        </Button>
                      </DialogActions>
                    </Dialog>
                    {showSubmitButton && (
                      <>
                        <Typography variant="body2" mb={2}>
                          {t("IWallet.SendEmailImportantNote")}
                        </Typography>
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.AccessCode}
                        />
                        <Box textAlign="center" mt={2}>
                          <Button
                            variant="contained"
                            type="button"
                            color="primary"
                            onClick={() => {
                              const accessCode =
                                methods.getValues("AccessCode");
                              CompareAccessCode({ AccessCode: accessCode });
                            }}
                          >
                            {t("Common.Submit")}
                          </Button>

                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ ml: 2 }}
                            onClick={SendEmail}
                            disabled={ResendButtonDisable}
                          >
                            {t("IWallet.ReSend Code")}
                          </Button>
                        </Box>
                      </>
                    )}
                    <Typography align="center" my={1} variant="body2">
                      {t("IWallet.iWallet USDC DISCLAIMER")}
                    </Typography>
                    <Grid item xs={12} sm={6} md={12}>
                      <Controller
                        name="checked1"
                        control={control}
                        rules={{ validate: checkbox1Validator }}
                        render={({ field, fieldState: { error } }) => (
                          <>
                            <FormControlLabel
                              control={<Checkbox {...field} />}
                              label={
                                <Typography variant="body2">
                                  {t("IWallet.Terms and Conditions1")}
                                </Typography>
                              }
                            />
                            {error && (
                              <Typography variant="caption" color="error">
                                {error.message}
                              </Typography>
                            )}
                          </>
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={12}>
                      <Controller
                        name="checked2"
                        control={control}
                        rules={{ validate: checkbox1Validator }}
                        render={({ field, fieldState: { error } }) => (
                          <>
                            <FormControlLabel
                              control={<Checkbox {...field} />}
                              label={
                                <Typography variant="body2">
                                  {t("IWallet.Terms and Conditions2 USDC")}
                                </Typography>
                              }
                            />
                            {error && (
                              <Typography variant="caption" color="error">
                                {error.message}
                              </Typography>
                            )}
                          </>
                        )}
                      />
                    </Grid>
                    {disable && (
                      <Typography align="center" color="error" sx={{ mb: 2 }}>
                        {t("IWallet.AlreadyRequested")}
                        {getRemainingDays}
                        {t("IWallet.Days")}
                      </Typography>
                    )}

                    {bitcoinAddressRequired && (
                      <Typography align="center" color="error" sx={{ mb: 2 }}>
                        {t("IWallet.USDCWalletAddressRequired")}{" "}
                      </Typography>
                    )}
                    <Box textAlign="center" pb={1} sx={{ mt: 2 }}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={
                          disable ||
                          bitcoinAddressRequired ||
                          isiWalletCreated.Earnings === 0 ||
                          isiWalletCreated.Earnings === undefined ||
                          isiWalletCreated.Earnings <
                            getiWalletSummary.minimumWithdrawalAmount ||
                          isiWalletCreated.Earnings >
                            iWalletBalance - parseFloat(getFeeList.USDC)
                        }
                      >
                        {t("IWallet.RequestWithdraw")}
                      </Button>
                    </Box>
                  </form>
                )}
              </Card>
            </Stack>
          </Card>
        </Box>
      </Box>
      <CommonSnackBar snackObj={snack} closeSnack={closeSnack} buttonProp />
    </>
  );
};

export default WithDrawFunds;
